<template>
  <div class="container">
    <CommonProcess moduleName="notRegistered" :isShowNum="isShowNum"/>
    <Button :btnConfig="btnConfig" v-if="isShowBtn"/>
    <div class="applyNum" v-if="!isShowFinal">- 已有{{activityInfo.apply_num || 0}}人报名 -</div>
    <div class="final" v-if="isShowFinal">活动已经结束了哦～</div>
  </div>
</template>
<script>
import CommonProcess from '../common/commonProcess'
import Button from '../common/button'

export default {
  name: 'notRegistered',
  components: {
    Button,
    CommonProcess
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    buttonText: {
      type: String
    },
    isLogin: {
      type: Boolean
    }
  },
  data() {
    return {
      btnConfig: {
        btnText: this.buttonText,
        from: 'signup',
        fn: () => {
          this.$xesLogger.clickMsg({
            params: { clickid: '10.0.3', elemname: '点击报名入口' }
          })
          this.$router.push({
            name: 'apply'
          })
        }
      }
    }
  },
  computed: {
    isShowBtn() {
      return !this.isLogin || (this.isLogin && this.activityInfo.apply_status === 0 && this.activityInfo.activity_status < 2)
    },
    isShowNum() {
      return !this.isLogin || (this.isLogin && this.activityInfo.apply_status === 0 && this.activityInfo.activity_status < 2)
    },
    isShowFinal() {
      return this.isLogin && this.activityInfo.apply_status === 0 && this.activityInfo.activity_status >= 2
    }
  },
  watch: {
    isLogin(value) {
      if (this.activityInfo.activity_status < 2) {
        return
      }
      if (value) {
        this.btnConfig.btnText = '立即报名'
      } else {
        this.btnConfig.btnText = '登录'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  position: relative;

  .title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: chocolate;
  }

  & /deep/ .btn-wrapper {
    position: absolute;
    top: 59%;
    left: 50%;
    margin-left: -130px;
  }

  .applyNum {
    position: absolute;
    bottom: 20px;
    width: 100%;
    font-size: 13px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: center;
    color: #666;
  }

  .final {
    position: absolute;
    bottom: 40px;
    width: 100%;
    font-size: 34px/2;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
    color: #666;
  }
}
</style>
